// extracted by mini-css-extract-plugin
export default {"QRCodeIronMedal":"QRCodeIronMedal_QRCodeIronMedal__PU8xB"};